import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import { applySeo } from '@/lib/seo';

export default function MentionsLegales() {
  useEffect(() => {
    applySeo({
      title: 'Mentions légales | Easy Car',
      description: "Mentions légales du site easycar.re et informations légales de CM MOTORS – EASY CAR à La Réunion.",
      canonical: 'https://easycar.re/mentions-legales',
    });

    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main className="pt-24 md:pt-28 pb-16 md:pb-20">
        <div className="w-full px-4 md:px-6 lg:px-10 max-w-3xl mx-auto">
          <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            Mentions légales
          </h1>
          <p className="text-foreground-500 text-xs md:text-sm mt-2">
            Dernière mise à jour : 24 septembre 2026
          </p>

          <div className="bg-white rounded-lg border border-background-200 p-5 md:p-10 mt-6 md:mt-8">
            {/* 1. Éditeur du site */}
            <section>
              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-4">
                1. Éditeur du site
              </h2>
              <div className="space-y-4 text-sm md:text-[15px] text-foreground-700 leading-relaxed">
                <p>Le présent site easycar.re est édité par :</p>

                <div className="space-y-1">
                  <p className="font-heading font-semibold text-foreground-900">CM MOTORS</p>
                  <p>Enseigne : EASY CAR</p>
                  <p>Entreprise unipersonnelle à responsabilité limitée (EURL)</p>
                  <p>Capital social : 786 €</p>
                </div>

                <div className="space-y-0.5">
                  <p className="font-semibold text-foreground-900">Siège social :</p>
                  <p>57 Rue du Général de Gaulle</p>
                  <p>97430 Le Tampon</p>
                  <p>La Réunion – France</p>
                </div>

                <div className="space-y-0.5">
                  <p>SIREN : 852 897 248</p>
                  <p>SIRET du siège : 852 897 248 00013</p>
                  <p>RCS : 852 897 248 RCS Saint-Pierre de La Réunion</p>
                  <p>N° TVA intracommunautaire : FR51 852 897 248</p>
                  <p>Code APE : 45.11Z</p>
                </div>

                <div className="space-y-0.5">
                  <p>
                    Téléphone :{' '}
                    <a
                      href="tel:+262692505551"
                      className="text-primary-600 hover:text-primary-700 transition-colors"
                    >
                      0692 50 55 51
                    </a>
                  </p>
                  <p>
                    E-mail :{' '}
                    <a
                      href="mailto:easycar974@gmail.com"
                      className="text-primary-600 hover:text-primary-700 transition-colors"
                    >
                      easycar974@gmail.com
                    </a>
                  </p>
                </div>

                <div className="space-y-0.5">
                  <p className="font-semibold text-foreground-900">Établissement secondaire :</p>
                  <p>153 Route de la Ligne Paradis</p>
                  <p>97410 Saint-Pierre</p>
                  <p>La Réunion – France</p>
                </div>

                <p>SIRET de l'établissement de Saint-Pierre : 852 897 248 00039</p>
              </div>
            </section>

            {/* 2. Directeur de la publication */}
            <section className="mt-8 pt-8 border-t border-background-200">
              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-4">
                2. Directeur de la publication
              </h2>
              <div className="space-y-2 text-sm md:text-[15px] text-foreground-700 leading-relaxed">
                <p>Directeur de la publication : Chane Mamode PANDJOU</p>
                <p>Qualité : Gérant de CM MOTORS</p>
              </div>
            </section>

            {/* 3. Hébergement */}
            <section className="mt-8 pt-8 border-t border-background-200">
              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-4">
                3. Hébergement
              </h2>
              <div className="space-y-4 text-sm md:text-[15px] text-foreground-700 leading-relaxed">
                <p>Le site easycar.re est hébergé par :</p>
                <div className="space-y-0.5">
                  <p className="font-heading font-semibold text-foreground-900">LWS – Ligne Web Services</p>
                  <p>SAS au capital de 500 000 €</p>
                  <p>10 rue Penthièvre</p>
                  <p>75008 Paris</p>
                  <p>France</p>
                </div>
                <div className="space-y-0.5">
                  <p>SIRET : 851 993 683 00024</p>
                  <p>RCS Paris : 851 993 683</p>
                  <p>
                    Téléphone :{' '}
                    <a
                      href="tel:+33177623003"
                      className="text-primary-600 hover:text-primary-700 transition-colors"
                    >
                      01 77 62 30 03
                    </a>
                  </p>
                  <p>
                    Site :{' '}
                    <a
                      href="https://www.lws.fr"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary-600 hover:text-primary-700 transition-colors"
                    >
                      https://www.lws.fr
                    </a>
                  </p>
                </div>
              </div>
            </section>

            {/* 4. Propriété intellectuelle */}
            <section className="mt-8 pt-8 border-t border-background-200">
              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-4">
                4. Propriété intellectuelle
              </h2>
              <div className="space-y-4 text-sm md:text-[15px] text-foreground-700 leading-relaxed">
                <p>
                  Le contenu du site easycar.re, notamment les textes, photographies, images, éléments
                  graphiques, logos, vidéos, icônes, éléments de mise en page et plus généralement
                  l'ensemble des éléments présents sur le site, est protégé par les règles applicables en
                  matière de propriété intellectuelle.
                </p>
                <p>
                  Sauf autorisation préalable, toute reproduction, représentation, modification,
                  adaptation ou exploitation, totale ou partielle, du contenu du site est interdite
                  lorsqu'elle porte atteinte aux droits de CM MOTORS ou de tiers.
                </p>
                <p>
                  Les marques, logos et autres éléments appartenant à des constructeurs automobiles ou à
                  des tiers restent la propriété de leurs titulaires respectifs.
                </p>
              </div>
            </section>

            {/* 5. Informations relatives aux véhicules */}
            <section className="mt-8 pt-8 border-t border-background-200">
              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-4">
                5. Informations relatives aux véhicules
              </h2>
              <div className="space-y-4 text-sm md:text-[15px] text-foreground-700 leading-relaxed">
                <p>
                  Les informations, photographies, caractéristiques, équipements, kilométrages, prix et
                  disponibilités des véhicules présentés sur le site sont communiqués à titre informatif.
                </p>
                <p>Easy Car s'efforce de maintenir ces informations à jour.</p>
                <p>
                  La disponibilité d'un véhicule peut évoluer et doit être confirmée directement auprès
                  d'Easy Car.
                </p>
                <p>Les photographies sont non contractuelles sauf indication contraire.</p>
                <p>
                  En cas de différence entre les informations présentes sur le site et les
                  caractéristiques contractuelles du véhicule lors de la vente, les documents
                  contractuels remis au client prévalent.
                </p>
              </div>
            </section>

            {/* 6. Responsabilité */}
            <section className="mt-8 pt-8 border-t border-background-200">
              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-4">
                6. Responsabilité
              </h2>
              <div className="space-y-4 text-sm md:text-[15px] text-foreground-700 leading-relaxed">
                <p>
                  CM MOTORS met tout en œuvre pour assurer l'exactitude et la disponibilité des
                  informations diffusées sur le site.
                </p>
                <p>
                  Toutefois, CM MOTORS ne peut garantir l'absence totale d'erreurs, d'interruptions ou
                  d'indisponibilités temporaires.
                </p>
                <p>
                  Le site peut contenir des liens permettant d'accéder à des services ou sites tiers,
                  notamment Google Maps, WhatsApp ou Facebook.
                </p>
                <p>
                  CM MOTORS n'exerce aucun contrôle sur ces services tiers et ne saurait être responsable
                  de leur contenu, de leur fonctionnement ou de leurs politiques de confidentialité.
                </p>
              </div>
            </section>

            {/* 7. Médiation de la consommation */}
            <section className="mt-8 pt-8 border-t border-background-200">
              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-4">
                7. Médiation de la consommation
              </h2>
              <div className="space-y-4 text-sm md:text-[15px] text-foreground-700 leading-relaxed">
                <p>
                  Conformément aux dispositions du Code de la consommation relatives au règlement amiable
                  des litiges, le consommateur peut recourir gratuitement au dispositif de médiation dont
                  relève CM MOTORS – EASY CAR, après avoir préalablement adressé une réclamation à
                  l'entreprise et lorsque le litige n'a pas pu être résolu directement avec celle-ci.
                </p>

                <div className="space-y-0.5">
                  <p className="font-semibold text-foreground-900">
                    Médiation / référent indiqué par Easy Car :
                  </p>
                  <p>Association des Conciliateurs de Justice de la Cour d'appel de Saint-Denis de La Réunion</p>
                  <p>SIDR Front de Mer</p>
                  <p>342 rue Fernand Colardeau</p>
                  <p>97410 Saint-Pierre</p>
                  <p>La Réunion</p>
                </div>

                <div className="space-y-0.5">
                  <p className="font-semibold text-foreground-900">Référent :</p>
                  <p>Jean-Paul JAKUBOWSKI</p>
                  <p>155 avenue de l'Europe</p>
                  <p>ZAC Chatoire</p>
                  <p>97430 Le Tampon</p>
                  <p>La Réunion</p>
                </div>

                <div className="space-y-0.5">
                  <p>
                    E-mail :{' '}
                    <a
                      href="mailto:jean-paul.jakubowski@conciliateurdejustice.fr"
                      className="text-primary-600 hover:text-primary-700 transition-colors break-all"
                    >
                      jean-paul.jakubowski@conciliateurdejustice.fr
                    </a>
                  </p>
                  <p>
                    Site internet :{' '}
                    <a
                      href="https://www.conciliateurs.fr/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary-600 hover:text-primary-700 transition-colors"
                    >
                      https://www.conciliateurs.fr/
                    </a>
                  </p>
                </div>
              </div>
            </section>
          </div>

          <div className="mt-8">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-primary-600 font-medium text-sm hover:text-primary-700 transition-colors"
            >
              <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center" />
              Retour à l'accueil
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}